import Modal from "react-bootstrap/Modal";
import { useIntl } from "react-intl";
import { useEffect, useState } from "react";
import { getCookie } from "../../slidebar/components/DarkMode";

export const ImageModal = ({ setImage, image, title }) => {
  const intl = useIntl();
  const [mode, setMode] = useState(getCookie("selectedTheme"));

  const handleClose = () => setImage(undefined);

  useEffect(() => {
    const handle = () => {
      setMode((prev) => (prev === "dark" ? "light" : "dark"));
    };

    window.addEventListener("setTheme", handle);

    return () => {
      window.removeEventListener("setTheme", handle);
    };
  }, []);

  return (
    <>
      <Modal
        show={!!image}
        onHide={handleClose}
        centered
        data-bs-theme={mode}
        className="zIndex-9999"
        backdropClassName="zIndex-9999"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {intl.formatMessage({
              id: title,
            })}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <img className="w-100" src={image} />
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={handleClose}
          >
            {intl.formatMessage({ id: "close" })}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
